class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    requestAnimationFrame(() => {
      this.openAccordionByURL()
    })
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.addEventListener('click', this.handleTrigger)
  }

  handleTrigger (event) {
    if (!event.target.closest(this.els?.trigger?.selector)) return

    const itemEl = event.target.closest(this.els?.item?.selector)

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    itemEl.setAttribute('aria-expanded', !currentState)
  }

  openAccordionByURL () {
    const params = new URLSearchParams(window.location.search)
    const openID = params.get('accordion')

    if (openID) {
      let target = document.querySelector(`[id="${openID}"]`)
      const accordionCopy = target?.parentElement.querySelector(
        '[data-accordion-copy]',
      )

      if (!target && openID.includes('-')) {
        const parts = openID.split('-')
        const accordionId = parts[parts.length - 1]
        target = document.querySelector(`[id="${accordionId}"]`)
      }

      if (target) {
        const itemEl = target.closest(this.els?.item?.selector)

        if (itemEl) {
          itemEl.setAttribute('aria-expanded', 'true')

          if (target.dataset.scrollPosition === 'bottom') {
            setTimeout(() => {
              accordionCopy.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
              })
            }, 100)
          } else {
            setTimeout(() => {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }, 100)
          }
        }
      }
    }
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
